// extracted by mini-css-extract-plugin
module.exports = {"completeBtn":"ClientSignature_completeBtn___oBts"};